import styled from "styled-components/macro";

export const TitleContainer = styled.div`
  position: relative;
  padding-left: 40px;
  margin-left: -6px;

  h3 {
    cursor: pointer;
  }

  .icon-toggle {
    position: absolute;
    left: 0;
    top: -12px;
  }
`;

export const ContentContainer = styled.div`
  overflow: hidden;

  &.collapse {
    height: auto;
  }

  &.collapsed {
    height: 0;
  }
`;
